const SEARCH_TRANSITION = {
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    }
  }

  export default SEARCH_TRANSITION;